import Packages from '@/pages/Packages'
import RechargeAnalytics from '@/pages/RechargeAnalytics'
import Orders from '@/pages/Orders'
import InteractionMotion from '@/components/InteractionMotion'
import { Routes, Route, Navigate } from 'react-router-dom'

import LoginPage from '@/pages/Login'
import DashboardPage from '@/pages/Dashboard'
import UsersPage from '@/pages/Users'
import FaceAuthPage from '@/pages/FaceAuth'
import AuditLogs from '@/pages/AuditLogs'
import ProductionCommissions from '@/pages/ProductionCommissions'
import TeamsPage from '@/pages/Teams'
import ModelCosts from '@/pages/ModelCosts'
import { ProtectedRoute } from '@/components/ProtectedRoute'

export default function App() {
  return (
    <>
      <InteractionMotion />

      <Routes>
        {import.meta.env.DEV && <Route path="/prototype/packages" element={<Packages prototypeMode />} />}
        {import.meta.env.DEV && <Route path="/prototype/model-costs" element={<ModelCosts prototypeMode />} />}
        {import.meta.env.DEV && <Route path="/prototype/model-costs/quotes" element={<ModelCosts prototypeMode initialView="estimate" />} />}
        <Route path="/model-costs" element={<ProtectedRoute requiredRoles={['finance', 'super_admin']}><ModelCosts /></ProtectedRoute>} />
        <Route path="/quotes" element={<ProtectedRoute requiredRoles={['finance', 'super_admin']}><ModelCosts initialView="estimate" /></ProtectedRoute>} />
        {import.meta.env.DEV && <Route path="/prototype/production-commissions" element={<ProductionCommissions prototypeMode />} />}
        <Route path="/recharge-analytics" element={<ProtectedRoute requiredRoles={['finance', 'super_admin', 'operator']}><RechargeAnalytics /></ProtectedRoute>} />
        <Route
          path="/packages"
          element={
            <ProtectedRoute requiredRoles={['finance', 'super_admin']}>
              <Packages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute requiredRoles={['finance', 'super_admin']}>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/face-auth"
          element={
            <ProtectedRoute
              requiredRoles={['operator', 'finance', 'super_admin']}
            >
              <FaceAuthPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/audit-logs"
          element={
            <ProtectedRoute requiredRoles={['super_admin']}>
              <AuditLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/copyright-trading/production-commissions"
          element={
            <ProtectedRoute>
              <ProductionCommissions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recharges"
          element={
            <ProtectedRoute requiredRoles={['finance', 'super_admin']}>
              <AuditLogs recharges />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route path="/teams" element={<ProtectedRoute><TeamsPage /></ProtectedRoute>} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="*"
          element={
            <div className="flex h-screen items-center justify-center text-slate-500">
              404 - 页面不存在
            </div>
          }
        />
      </Routes>
    </>
  )
}
